/**
 * iPadOS Workaround to detect scroll position.
 * In case when document height is changing and Safari is adopting
 * scroll to fit site footer into viewport, safari does not dispatch
 * scroll events at all. In this purpose we have to dispatch synthetic
 * scroll events manualy.
 *
 * We have assumption: if difference between `scrollHeight` and `innerHeight`
 * less then last scroll position which had been dispatched then
 * we have the situation and have to dispatch custom scroll event.
 */

import bowser from 'yola-bowser';
import view from '../../../../view';

const iPadOSScrollPositionWatcher = (liveDocument, frame) => {
  if (!bowser.iPadOS) return;

  let requestAnimationId;

  const watcher = () => {
    const scrollPosition = view.accessors.getScrollPosition();
    const maxScrollPosition =
      liveDocument.scrollingElement.scrollHeight - liveDocument.defaultView.innerHeight;

    if (maxScrollPosition < scrollPosition) {
      liveDocument.dispatchEvent(
        new CustomEvent('scroll', {
          detail: {
            scrollPosition: maxScrollPosition,
          },
        })
      );
    }
  };

  const intervalId = setInterval(() => {
    requestAnimationId = requestAnimationFrame(watcher);
  }, 16);

  frame.contentWindow.addEventListener(
    'unload',
    () => {
      cancelAnimationFrame(requestAnimationId);
      clearInterval(intervalId);
    },
    {
      once: true,
    }
  );
};

export default iPadOSScrollPositionWatcher;
